import moment from "moment";

import { userData } from "./functions";

import { getAge } from "./getAgeByDate";

import { formatDate, professionalClassCouncilValue } from "./format";

import api from "../services/api";

export const digitalCertificate = async ({
    title = null,
    data = [],
    exist_footer = false,
    item = null,
    created_at = null,
    signature = null,
}) => {
    try {
        if (item) {
            let { user, logo: sistema_logo_url, resident_no_photo_url } = userData();

            let { rest_home_name, logo_url: rest_home_logo_url } = user;

            let {
                resident: {
                    name: resident_name,
                    date_of_birth: resident_date_of_birth,
                    date_of_reception: resident_date_of_reception,
                    photo_url: resident_photo_url,
                },
                table: { table_id },
                table_name
            } = item;

            if (signature) {
                let text_signature = `${professionalClassCouncilValue({
                    id: item.table.user_professional_class_council_id,
                    name: item.table.user_name,
                    profile: item.table.user_profile_name,
                    cpf: item.table.user_cpf,
                    office: item.table.user_office,
                    value: item.table.user_professional_class_council_value,
                })} - ${formatDate(item.table.created_at)}`;

                data.push({
                    col1: {
                        exist: true,
                        text: text_signature,
                    },
                    col2: {
                        exist: false,
                        text: "",
                    },
                    col3: {
                        exist: false,
                        text: "",
                    },
                    col4: {
                        exist: false,
                        text: "",
                    },
                });
            }

            let pdf = {
                header: {
                    left: {
                        img: rest_home_logo_url,
                        text: rest_home_name
                    },
                    center: {
                        img: resident_photo_url ? resident_photo_url : resident_no_photo_url,
                        resident: {
                            name: resident_name,
                            date_of_birth: `Data de nascimento: ${moment(resident_date_of_birth).format('DD/MM/YYYY')} - ${getAge(resident_date_of_birth)} anos`,
                            date_of_reception: `Data de admissão: ${moment(resident_date_of_reception).format('DD/MM/YYYY')}`
                        }
                    },
                    right: {
                        img: sistema_logo_url,
                        date: created_at ? `Data: ${moment(created_at).format('DD/MM/YYYY')}` : null
                    },
                },
                content: {
                    title,
                    data
                },
                footer: {
                    exist: exist_footer,
                    text: ""
                }
            }

            await api.post("/certificate/pdf/create", { table_id, table_name, pdf });
        }
    } catch (error) {
        return { error: true, errors: ['Não foi possível assinar o documento.'] }
    }
}